import React from 'react';
import { Layers } from 'lucide-react';

const SupplierVariants = () => {
  return (
    <section className="min-h-screen p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl md:text-3xl font-philosopher text-primaryTextColor flex items-center gap-2">
          <Layers className="text-[#fba93d] w-7 h-7" />
          Product Variants
        </h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-10 flex flex-col items-center justify-center text-gray-500">
        <Layers className="w-16 h-16 text-gray-300 mb-4" />
        <h2 className="text-xl font-bold text-gray-700">Coming Soon</h2>
        <p className="mt-2 text-center max-w-md">The product variants management module is currently under development. You will be able to manage sizes, colors, and other variations here soon.</p>
      </div>
    </section>
  );
};

export default SupplierVariants;
